module.exports = __webpack_public_path__ + "static/media/airplane.284c7d4f.png";